// extracted by mini-css-extract-plugin
export var cardIcon = "_b4-4";
export var checkboxCard = "_b4-0";
export var checkboxCardSelected = "_b4-3";
export var disabled = "_b4-1";
export var outerBorder = "_b4-2";
export var spacerMedium = "_b4-7";
export var spacerSmall = "_b4-6";
export var spacerXsmall = "_b4-5";